/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated';
import { createLN2 } from '../../factoriesAny.js';
export var LN2Dependencies = {
  BigNumberDependencies: BigNumberDependencies,
  createLN2: createLN2
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesLN2.generated.js
// module id = 1437
// module chunks = 0